import { Store } from "pullstate";

export const GlobalStore = new Store({
  defaultCountryName: "Singapore",
  defaultCountryCode: "SG",
  availableCountries: ["SG", "MY"],
  passwordProtectedRoutes: ["product-portal"],
  config: undefined,
  countries: undefined,
  structure: undefined,
  currentCountry: undefined,
  currentCountryCode: undefined,
  whatsappMessage: "",
  changeCountry: undefined,
  closeTopBanner: undefined
});
